<template>
    <div class="polaroid-fixture" ref="poals">
        <div class="polaroid-container">
            <div class="polaroid-frame _tr draggable" v-for="(polaroid, key, index) in polaroids" :data-uid="polaroid.src" :style="{marginTop: polaroid.top + 'rem', zIndex: polaroid.index, transform: 'rotate(' + polaroid.rotation + 'deg)'}">
                <figure>
                    <img :src="polaroid.src" :alt="polaroid.caption || 'Foto'">
                </figure>
                <span class="_hand" v-html="polaroid.caption || '&nbsp;'"/>
            </div>
        </div>
    </div>
</template>

<script setup>
    import image1 from '@/img/image1.png'
    import image2 from '@/img/image2.png'
    import image3 from '@/img/image3.png'
    import image4 from '@/img/image4.png'

    import { ref, onMounted, computed, inject } from 'vue'
    import { useMassDraggable } from "@/common/composables/useMassDraggable"

    const poals = ref(null)
    const dragState = inject("dragState")

    useMassDraggable(poals, (figure) => {
        return polaroids?.get(figure.dataset.src) ?? null
    })

    // const imageMap = computed(() => new Map(polaroids.value.map(img => [img.src, { ...img, type: "addImage" }])))

    const polaroids = {
        "image1": {
            src: image1,
            // caption: 'moieem',
            rotation: -5.4,
            index: 2,
            top: 0,
            type: "image"
        }, 
        "image2": {
            src: image2,
            // caption: 'Bootje',
            rotation: 6.31,
            index: 1,
            top: 1,
            type: "image"
        }, 
        "image3": {
            src: image3,
            // caption: 'moieem',
            rotation: 2.67,
            index: 3,
            top: 1.5,
            type: "image"
        }, 
        "image4": {
            src: image4,
            // caption: 'moieem',
            rotation: -5.09,
            index: 0,
            top: 0,
            type: "image"
        }
    }
</script>

<style lang="scss">
    .polaroid {
        &-fixture {
            width: 100%;
            background: rgba(var(--white), 1);
            position: relative;
            z-index: 10;
        }

        &-container {
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin-top: -2rem;
            position: relative;
        }

        &-frame {
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            align-items: center;
            width: auto;
            margin: -2rem -1rem;
            padding: 0.75rem;
            // background: rgba(var(--white), 1);
            background: white;
            box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.16);

            figure {
                width: 100%;
            }

            span {
                width: 100%;
                margin: 0 0 -0.75rem;
                padding: 0.25rem 0;
                text-align: center;
                // mix-blend-mode: color-burn;
                color: rgba(11, 9, 40, 0.5);
            }
        }
    }
</style>
